// extracted by css-extract-rspack-plugin
export default {"container":"_bdd214fb","content":"_b5df5c75","pin":"_976c326b","inputWrapper":"_153590f9","labelText":"_5920b1e7"};